import { atom } from "recoil";

import { persistAtom } from "./persist";

// ponytail: kill switch, so ending the experiment does not require clearing
// every treatment user's localStorage.
export const UNLIMITED_ONLY_KILLED =
  process.env.REACT_APP_UNLIMITED_ONLY_KILL === "true";

export type TPaywallVariant = "unlimited_only" | "control";

// Single source of truth for atom → variant, shared by useUnlimitedOnlyPaywall
// and useAnalyticsContext so the kill switch flips the UI and the event tags
// together.
export const paywallVariantOf = (enabled: boolean): TPaywallVariant =>
  enabled && !UNLIMITED_ONLY_KILLED ? "unlimited_only" : "control";

// The hash assignment (or the internal-account force). The ?unlimitedonly QA
// override is deliberately NOT written here: a QA session must not leave the
// browser permanently assigned to an arm it was never hashed into.
export const UnlimitedOnlyPaywallState = atom<boolean>({
  key: "UnlimitedOnlyPaywall_v1",
  default: false,
  effects_UNSTABLE: [persistAtom],
});

// Which anonymousId the stored variant belongs to, so a cleared or rotated
// Rudder id is rebucketed instead of keeping a stale assignment.
export const UnlimitedOnlyBucketedIdState = atom<string | null>({
  key: "UnlimitedOnlyBucketedId_v1",
  default: null,
  effects_UNSTABLE: [persistAtom],
});
